export default __webpack_public_path__ + "static/media/photo 20.57bedfdc.jpg";